/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var CreateObserver = __webpack_require__(90);

	var brandHomepageIntro = function brandHomepageIntro() {
	    CreateObserver.observe('.experience-commerce_layouts-intro', {
	        onChange: function onChange(entry) {
	            entry.target.classList.toggle('is-sticked', entry.intersectionRatio < 1);
	        }
	    });

	    var carousel = document.querySelector(".cc-intro-links");
	    var slides = document.querySelectorAll(".cc-intro-link");
	    var prevButton = document.querySelector(".cc-intro-links-arrow--prev");
	    var nextButton = document.querySelector(".cc-intro-links-arrow--next");

	    if (!carousel || !prevButton || !nextButton || slides.length === 0) {
	        console.warn("Brand homepage categories or navigation arrows not found.");
	        return;
	    }

	    function updateArrows() {
	        var maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;

	        if (maxScrollLeft <= 0) {
	            // If scrolling is not needed, hide both arrows
	            prevButton.classList.remove("visible");
	            nextButton.classList.remove("visible");
	        } else if (carousel.scrollLeft <= 0) {
	            // If at the start, hide the previous arrow
	            prevButton.classList.remove("visible");
	            nextButton.classList.add("visible");
	        } else if (carousel.scrollLeft >= maxScrollLeft) {
	            // If at the end, hide the next arrow
	            prevButton.classList.add("visible");
	            nextButton.classList.remove("visible");
	        } else {
	            // Otherwise, show both arrows
	            prevButton.classList.add("visible");
	            nextButton.classList.add("visible");
	        }
	    }

	    /**
	     * Moves the carousel horizontally by the width of one slide.
	     * Direction is determined by the `positive` parameter.
	     *
	     * @param {boolean} [positive=true] - If true, moves the carousel to the next slide; if false, moves it to the previous slide.
	     */
	    function handleCarouselMove() {
	        var positive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

	        var slideWidth = slides[0].clientWidth + parseFloat(getComputedStyle(carousel).gap || 0);
	        carousel.scrollLeft = positive ? carousel.scrollLeft + slideWidth // Scroll forward
	        : carousel.scrollLeft - slideWidth; // Scroll backward

	        updateArrows();
	    }

	    prevButton.addEventListener("click", function () {
	        return handleCarouselMove(false);
	    });
	    nextButton.addEventListener("click", function () {
	        return handleCarouselMove();
	    });

	    // Monitor scrolling and update arrows
	    carousel.addEventListener("scroll", updateArrows);

	    // Update arrows on page load
	    updateArrows();

	    // Update arrows when the window is resized
	    window.addEventListener("resize", updateArrows);
	};

	try {
	    brandHomepageIntro();
	} catch (error) {
	    console.error("An error occurred while initializing the brand homepage intro:", error);
	}

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

	'use strict';

	/**
	 * CreateObserver - Module for monitoring element visibility using IntersectionObserver
	 */

	var CreateObserver = function () {
	    /**
	     * Initializes the observation of an element with customizable options.
	     *
	     * @param {string} selector - The selector of the target element.
	     * @param {Object} options - Observation options.
	     * @param {Array<number>} [options.threshold=[1]] - Visibility thresholds (0 - 1).
	     * @param {Element|null} [options.root=null] - The container for observation (defaults to the viewport).
	     * @param {string} [options.rootMargin="0px"] - The margin around the root for observation.
	     * @param {Function} [options.onChange] - Callback function triggered when the visibility changes.
	     */
	    var observe = function observe(selector) {
	        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	        var el = document.querySelector(selector);

	        if (!el) {
	            console.error("Element with selector '" + selector + "' not found.");
	            return;
	        }

	        var _options$threshold = options.threshold,
	            threshold = _options$threshold === undefined ? [1] : _options$threshold,
	            _options$root = options.root,
	            root = _options$root === undefined ? null : _options$root,
	            _options$rootMargin = options.rootMargin,
	            rootMargin = _options$rootMargin === undefined ? "0px" : _options$rootMargin,
	            _options$onChange = options.onChange,
	            onChange = _options$onChange === undefined ? function (entry) {
	            // Default behavior: toggle "is-sticked" class
	            entry.target.classList.toggle("is-sticked", entry.intersectionRatio < 1);
	        } : _options$onChange;

	        // Create a new IntersectionObserver instance with user-defined options

	        var observer = new IntersectionObserver(function (entries) {
	            entries.forEach(onChange);
	        }, { threshold: threshold, root: root, rootMargin: rootMargin });

	        observer.observe(el);
	    };

	    return {
	        observe: observe
	    };
	}();

	module.exports = CreateObserver;

/***/ })

/******/ });